// src/components/Reports/SalesReport.jsx
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { reportService } from '../../services/reports';
import LoadingSpinner from '../Common/LoadingSpinner';

export default function SalesReport({ dateRange }) {
  const { data, isLoading } = useQuery({
    queryKey: ['sales-report', dateRange],
    queryFn: () => reportService.getSalesReport(dateRange),
  });

  if (isLoading) return <LoadingSpinner />;

  return (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <div className="p-4 border-b">
        <h3 className="text-lg font-semibold">Sales Report</h3>
      </div>
      <div className="p-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
          <div className="bg-blue-50 p-3 rounded">
            <p className="text-sm text-blue-600">Total Sales</p>
            <p className="text-xl font-bold">KES {data?.summary?.totalSales?.toLocaleString() || 0}</p>
          </div>
          <div className="bg-green-50 p-3 rounded">
            <p className="text-sm text-green-600">Transactions</p>
            <p className="text-xl font-bold">{data?.summary?.transactionCount || 0}</p>
          </div>
          <div className="bg-purple-50 p-3 rounded">
            <p className="text-sm text-purple-600">Average Value</p>
            <p className="text-xl font-bold">KES {data?.summary?.averageTransactionValue?.toLocaleString() || 0}</p>
          </div>
          <div className="bg-yellow-50 p-3 rounded">
            <p className="text-sm text-yellow-600">Total Tax</p>
            <p className="text-xl font-bold">KES {data?.summary?.totalTax?.toLocaleString() || 0}</p>
          </div>
        </div>
        
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-2 text-left">Date</th>
                <th className="px-4 py-2 text-left">Invoice #</th>
                <th className="px-4 py-2 text-left">Customer</th>
                <th className="px-4 py-2 text-right">Amount</th>
                <th className="px-4 py-2 text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              {data?.data?.map((sale, idx) => (
                <tr key={idx} className="border-t">
                  <td className="px-4 py-2">{new Date(sale.created_at).toLocaleDateString()}</td>
                  <td className="px-4 py-2">{sale.invoice_number}</td>
                  <td className="px-4 py-2">{sale.customer_name || 'Walk-in'}</td>
                  <td className="px-4 py-2 text-right">KES {sale.total_amount?.toLocaleString()}</td>
                  <td className="px-4 py-2">
                    <span className={`px-2 py-1 text-xs rounded-full ${
                      sale.status === 'paid' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
                    }`}>
                      {sale.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}